define(
    'modules/alert-box',[
        'modules/overlay-box',
        'settings'
    ],
    function (OverlayBox, settings) {
        /**
         * @class OverlayBox
         */
        var AlertBox = (function () {
            /**
             * Alert box is extention of overlay box. It content message and cta buttons in needed.
             *
             * @param {String} [msg] Message in alert box
             * @constructor
             */
            function AlertBox(msg) {
                this.msg = msg;
                this.ctaList = [];
                this.destroyList = $.Deferred();
            }


            AlertBox.prototype.show =  function () {
                this.ob = new OverlayBox(
                    settings.templates.alertBox, {
                        msg: this.msg,
                        paragraphs: this.paragraphs,
                        ctaList: this.ctaList
                });

                this.ob.setup();
                this.ob.load();
                this.ob.show();


                var _this = this;
                this.ob.addDestroyCallback(function() {
                    _this.destroyList.resolve();
                });
            };

            AlertBox.prototype.hide =  function () {
                this.ob.destroy();
                this.destroyList.resolve();
            };

            AlertBox.prototype.addParagraph =  function (msg) {
                if (!this.paragraphs) {
                    this.paragraphs = [];
                }

                this.paragraphs.push(msg);
            };

            /**
             * Adds "call to action" button to alert with callback
             * @param {String}   [msg] Message on the button
             * @param {Function} [callback] All callbacks close the overlay box
             * @param {String}   [position=right] left,right
             * @param {bool}     [inverse=false] 
             */
            AlertBox.prototype.addCTA =  function (msg, callback, position, inverse) {
                var cta = {
                    msg: msg,
                    callback: callback,
                    position: position ? position: 'right',
                    inverse: inverse ? 'button--inverse' : '',
                    callbackID: 'overlay-box__action-' + this.ctaList.length
                };

                this.ctaList.push(cta);

                if (callback) {
                    var eventCallback = function(e) {
                        e.preventDefault();
                        callback.call();
                    };
                    $('html').on('click', '#' + cta.callbackID, eventCallback);

                }

                this.destroyList.done(function() {
                    $('html').off('click', '#' + cta.callbackID, eventCallback);
                });
            };

            return AlertBox;
        })();

        return AlertBox;
    }
);
